<ub-heading i18n>Emails</ub-heading>
<div>
  <h4>Primary Email Address</h4>
  <div>{{primaryEmail}}</div>
</div>
@for (secondaryEmail of secondaryEmails; track secondaryEmail) {
  <div>
    <h4>Secondary Email Address</h4>
    <div>{{secondaryEmail}}</div>
  </div>
}
